import React, { memo, useCallback } from 'react';
import { message, Tooltip } from 'antd';
import { attachmentsActions } from '../../../actions/attachments.actions';
import { FileIcon } from '../../../resource/icons';

const PDFPreviewIcon = ({ parentId, attachment, parentType }) => {
  const handlePDFPreview = useCallback(() => {
    try {
      attachmentsActions.openAttachment(
        parentId,
        attachment.fileName,
        attachment.name,
        parentType
      );
    } catch (error) {
      message.error('Не удалось открыть PDF-файл');
      console.error(error);
    }
  }, [parentId, attachment.fileName, attachment.name, parentType]);

  return (
    <Tooltip title="Просмотр">
      <FileIcon onClick={handlePDFPreview} />
    </Tooltip>
  );
};

export default memo(PDFPreviewIcon);
